module.exports = __webpack_public_path__ + "static/img/4_1_1.f5bd627b.jpg";